<template>
    <div class="cs_preloader cs_white_bg">
      <div class="cs_preloader_in position-relative">
        <span></span>
      </div>
    </div>
</template>

<script>
export default {
    name: "Preloader"
};
</script>
